import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-delect-acount-dummy',
  templateUrl: './delect-acount-dummy.component.html',
  styleUrl: './delect-acount-dummy.component.scss'
})
export class DelectAcountDummyComponent {
  delete_memeberform: any = FormGroup;
  submitted = false;
  constructor( private fb: FormBuilder){
    this.delete_memeberform = this.fb.group({
      contact_no: ['', [Validators.required,Validators.pattern("^[0-9]*$"),Validators.minLength(7)]],
      action: '',
    })
  }
  get f() {
    return this.delete_memeberform.controls;
  }

  submit(){
    if(this.delete_memeberform.valid){
   this.submitted = true;
    }
  }
}
